<div [ngClass]="{'wrap-product-name': wrapProductName}">
  {{ candidate.product }}
  @if (showCopy) {
    <app-copy-to-clipboard [text]="candidate.product" />
  }
</div>
<div class="small">
  <strong>NDC:</strong> {{ candidate.ndc }} @if (isFlaggedForEsp) {
  <span class="flagged-for-esp p-1">ESP</span>
}
@if (showCopy) {
  <app-copy-to-clipboard [text]="candidate.ndc" />
}
</div>
